import { render, staticRenderFns } from "./FindWordsContainer.vue?vue&type=template&id=01b64168&scoped=true"
import script from "./FindWordsContainer.vue?vue&type=script&lang=ts"
export * from "./FindWordsContainer.vue?vue&type=script&lang=ts"
import style0 from "./FindWordsContainer.vue?vue&type=style&index=0&id=01b64168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b64168",
  null
  
)

export default component.exports